// extracted by mini-css-extract-plugin
var _1 = "RentalPortalMatchCriteriaPopoverHeader-moduleRentalPortalMatchCriteriaPopoverHeader__zFIPu";
var _2 = "RentalPortalMatchCriteriaPopoverHeader-modulebadge__BLBcg";
var _3 = "RentalPortalMatchCriteriaPopoverHeader-modulecoverage__I3Rvb";
export { _1 as "RentalPortalMatchCriteriaPopoverHeader", _2 as "badge", _3 as "coverage" }
